'use client';

import React, { memo, useMemo } from 'react';
import AppIcon from './AppIcon';
import AppImage from './AppImage';

interface AppLogoProps {
  src?: string;
  text?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
  sizes?: string;
}

const AppLogo = memo(function AppLogo({
  src = '/assets/images/app_logo.png',
  text,
  iconName = 'SparklesIcon',
  size = 64,
  className = '',
  onClick,
  sizes,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center gap-2'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  return (
    <div data-component-id="src/components/ui/AppLogo.tsx:34:4" data-component-path="src/components/ui/AppLogo.tsx" data-component-line="34" data-component-end-line="51" data-component-file="AppLogo.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22%5Bvar%3AcontainerClassName%5D%22%7D" className={containerClassName} onClick={onClick}>
      {src ? (
        <AppImage data-component-id="src/components/ui/AppLogo.tsx:36:8" data-component-path="src/components/ui/AppLogo.tsx" data-component-line="36" data-component-end-line="46" data-component-file="AppLogo.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22src%22%3A%22%5Bvar%3Asrc%5D%22%2C%22alt%22%3A%22Logo%22%2C%22className%22%3A%22flex-shrink-0%22%7D"
          src={src}
          alt="Logo"
          width={size}
          height={size}
          className="flex-shrink-0"
          priority={true}
          unoptimized={src.endsWith('.svg')}
          sizes={sizes || `${size}px`}
          quality={100}
        />
      ) : (
        <AppIcon data-component-id="src/components/ui/AppLogo.tsx:48:8" data-component-path="src/components/ui/AppLogo.tsx" data-component-line="48" data-component-end-line="48" data-component-file="AppLogo.tsx" data-component-name="AppIcon" data-component-content="%7B%22elementName%22%3A%22AppIcon%22%2C%22name%22%3A%22%5Bvar%3AiconName%5D%22%2C%22className%22%3A%22flex-shrink-0%22%7D" name={iconName} size={size} className="flex-shrink-0" />
      )}
      {text && <span data-component-id="src/components/ui/AppLogo.tsx:50:15" data-component-path="src/components/ui/AppLogo.tsx" data-component-line="50" data-component-end-line="50" data-component-file="AppLogo.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-xl%20font-bold%22%7D" className="text-xl font-bold">{text}</span>}
    </div>
  );
});

export default AppLogo;